export default __webpack_public_path__ + "static/media/uintlab.a558b9b0.png";